import ApiService from "@/utils/request"

export const schoolServe = {
  getCount() {
    return ApiService.get(`alumni/college/count/`)
  },
  getForeignAreaCount() {
    return ApiService.get(`alumni/college/foreign/count/`)
  },
  getChinaAreaCount() {
    return ApiService.get(`alumni/college/china/count/`)
  },
  getWzArea() {
    return ApiService.get(`alumni/division/wenzhou/`)
  },
  getChinaSchool(params) {
    return ApiService.query(`alumni/college/china/page/`, params)
  },
  getWzSchool(code, params) {
    return ApiService.query(`alumni/college/china/wenzhou/${code}/`, params)
  },
  search(params) {
    return ApiService.query(`alumni/search/college/`, params)
  },
  getDropdownSchool(params) {
    return ApiService.query(`alumni/college/`, params)
  },
  getForeignSchool(code) {
    return ApiService.get(`alumni/college/foreign/${code}/`)
  },
  getSchoolAlumni(id, params) {
    return ApiService.query(`alumni/college/${id}/alumni/`, params)
  },
  getClassMates(id, params) {
    return ApiService.query(`alumni/education/mates/${id}/`, params)
  },
  getFacultyAlumni(cId, fId, params) {
    return ApiService.query(
      `alumni/university/${cId}/faculties/${fId}/`,
      params
    )
  },
  getDisciplineAlumni(school, discipline, params) {
    return ApiService.query(
      `alumni/university/${school}/discipline/${discipline}/`,
      params
    )
  },
  getYearAlumni(id, params) {
    return ApiService.query(`alumni/university/mates/${id}/`, params)
  },
  getSchoolFaculties(id) {
    return ApiService.query(`alumni/college/${id}/faculties/`)
  },
  getSchoolMateCount(id) {
    return ApiService.query(`alumni/college/${id}/count/`)
  },
  getSchoolDiscipline(params) {
    const { level = "", parent = "", name = "" } = params
    return ApiService.query(`alumni/discipline`, {
      level,
      parent,
      name
    })
  }
}
